import { Flex, Table, TruncatedText } from "@nulogy/components";
import capitalize from "lodash/capitalize";
import pick from "lodash/pick";
import React from "react";
import styled, { useTheme } from "styled-components";
import DateTime from "utils/DateTime";
import Time from "utils/Time";
import Accordion from "./Accordion";
import AvailabilityCheckbox from "./AvailabilityCheckbox";

const CenteredCell = styled(Flex)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: theme.sizes.x2,
  paddingTop: theme.sizes.x2,
  width: "108px",
}));

function renderDefaultAvailability({ column, row }) {
  const day = column.dataKey;
  const shiftAvailable = row.shiftAvailability[day];

  return (
    <CenteredCell>
      <AvailabilityCheckbox
        className={`spec-default-availability-${day}`}
        data-testid={`${row.id}-${day}`}
        disabled={!shiftAvailable}
        field={`defaultAvailabilities[${row.defaultAvailabilityIndex}][${day}]`}
      />
    </CenteredCell>
  );
}

function renderLineHeader({ cellData }) {
  return (
    <CenteredCell className="spec-line-name">
      <TruncatedText fullWidth textAlign="center" width="100px">
        {cellData}
      </TruncatedText>
    </CenteredCell>
  );
}

function headerFormatter({ label }) {
  return <CenteredCell>{label}</CenteredCell>;
}

function dayColumn(dataKey) {
  return {
    cellRenderer: renderDefaultAvailability,
    dataKey,
    headerFormatter,
    label: capitalize(dataKey),
    width: "108px",
  };
}

const columns = [
  { cellRenderer: renderLineHeader, dataKey: "name", headerFormatter, width: "108px" },
  dayColumn("monday"),
  dayColumn("tuesday"),
  dayColumn("wednesday"),
  dayColumn("thursday"),
  dayColumn("friday"),
  dayColumn("saturday"),
  dayColumn("sunday"),
];

export default function DefaultAvailabilityTable({ defaultAvailabilities, lines, shift }) {
  const theme = useTheme();
  const rowsForShift = () =>
    lines.map((line) => {
      const defaultAvailabilityIndex = defaultAvailabilityIndexFor(line);

      return {
        ...line,
        ...pick(defaultAvailabilities[defaultAvailabilityIndex], DateTime.DAYS_OF_WEEK),
        defaultAvailabilityIndex,
        shiftAvailability: pick(shift, DateTime.DAYS_OF_WEEK),
      };
    });

  const defaultAvailabilityIndexFor = (line) =>
    defaultAvailabilities.findIndex(
      (defaultAvailability) => defaultAvailability.shift.id === shift.id && defaultAvailability.line.id === line.id,
    );

  const shiftTime = `${Time.to12Hour(shift.startTime)} - ${Time.to12Hour(shift.endTime)}`;

  return (
    <Accordion heading={shift.name} sideNote={shiftTime}>
      <Table
        columns={columns}
        compact
        data-testid="table"
        rows={rowsForShift()}
        style={{ marginBottom: theme.sizes.x3 }}
      />
    </Accordion>
  );
}
